module.exports = __webpack_public_path__ + "a77f03934c02e8794fa759254bf673b9.svg";